<template>
  <div class="teacher-assess-page">
    <div class="page-title">
      <div class="words-box">
        <span class="title">教师点评</span>
        <el-button
                v-if="!is_view"
                type="primary"
                size="small"
                icon="el-icon-info"
                @click="goCorrectExplainView"
                >
            批改说明
        </el-button>
        <span class="name">试题：{{paperName}}</span>
      </div>
      <div class="button-box" v-if="!is_view">
        <el-button
                type="primary"
                size="middle"
                plain
                @click="cancel"
                >
            取消
        </el-button>
        <el-button
                type="primary"
                size="middle"
                @click="save"
                >
            保存
        </el-button>
      </div>
    </div>
    <div class="page-content">
      <div class="part">
        <div class="part-title">
          教师评分<font class="red" v-if="!is_view">*</font>
        </div>
        <div class="part-content" v-if="!is_view">
          <el-input-number v-model="num" controls-position="right" size="small" step-strictly :step="0.1" :min="0" placeholder="请输入" @blur="check"></el-input-number>
          <span class="red font-12" v-show="err_msg">{{err_msg}}</span>
        </div>
        <div class="part-content" v-else>
          <span>{{num}}分</span>
        </div>
      </div>
      <div class="part">
        <div class="part-title">
          答题卡批改<font class="red" v-if="!is_view">*</font>
        </div>
        <div class="part-content">
          <!-- <el-upload
            v-if="!is_view"
            ref="upload"
            :action="uploadUrl"
            list-type="picture-card"
            :http-request="uploadFile"
            :file-list="local_pic_arr"
            :on-preview="handlePictureCardPreview"
            :on-remove="handleRemove"
            :before-upload="beforeUpload"
            auto-upload>
              <i slot="default" class="el-icon-plus"></i>
          </el-upload> -->
          <el-upload
            :class="is_view ? 'is_view' : ''"
            ref="upload"
            :action="uploadUrl"
            list-type="picture-card"
            :http-request="uploadFile"
            :file-list="local_pic_arr"
            :before-upload="beforeUpload"
            auto-upload>
              <i slot="default" class="el-icon-plus"></i>
              <div slot="file" slot-scope="{file}" style="width: 100%; height: 100%;">
                <img
                  class="el-upload-list__item-thumbnail"
                  :src="file.url" alt=""
                >
                <span class="el-upload-list__item-actions">
                  <span
                    class="el-upload-list__item-preview"
                    @click="handlePictureCardPreview(file)"
                  >
                    <i class="el-icon-zoom-in"></i>
                  </span>
                  <span
                    v-if="!is_view"
                    class="el-upload-list__item-delete"
                    @click="handleRemove(file)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </div>
          </el-upload>
          <span v-if="is_view && !local_pic_arr.length">无</span>
          <span class="red font-12" v-show="pic_err_msg">{{pic_err_msg}}</span>
        </div>
      </div>
      <!-- <div class="part">
        <div class="part-title">
          视频点评<font class="red">*</font>
        </div>
        <div class="part-content">
          <record-video :value.sync="RecordVideo" :maxRecordTime="10" @uploadFile="videoUpload" @errorLister="errorLister"></record-video>
          <a @click="RecordVideoOpen">录制视频</a>
        </div>
      </div> -->
      <div class="part">
        <div class="part-title">
          文字点评<font class="red">*</font>
        </div>
        <div class="part-content">
          <div class="item-title" v-show="!question_mode">
            总体评价
          </div>
          <div class="item-content" v-show="!question_mode">
            <ueditor id="ueditor_1" :config="config" ref="ueditor_1"></ueditor>
          </div>
          <div class="item-title">
            问题
          </div>
          <div class="item-content">
            <ueditor id="ueditor_2" :config="config" ref="ueditor_2"></ueditor>
          </div>
          <div class="item-title" v-show="!question_mode">
            优点
          </div>
          <div class="item-content" v-show="!question_mode">
            <ueditor id="ueditor_3" :config="config" ref="ueditor_3"></ueditor>
          </div>
          <div class="item-title" v-show="!question_mode">
            建议
          </div>
          <div class="item-content" v-show="!question_mode">
            <ueditor id="ueditor_4" :config="config" ref="ueditor_4"></ueditor>
          </div>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
import Ueditor from '@/components/ueditor'
import RecordVideo from '@/components/record-video'
import global_ from "../../global/index"
import axios from 'axios'

export default {
  components: {
    Ueditor,
    RecordVideo
  },
  data () {
    return {
      RecordVideo: false,
      question_mode: 0,
      pic_err_msg: '',
      err_msg: '',
      question_evaluation: '',
      question_issue: '',
      question_merit: '',
      question_advice: '',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      uploadUrl: '',
      config: {
        // enableAutoSave: false,
        readonly: false,
        initialFrameWidth: '100%',
        initialFrameHeight: 200,
        elementPathEnabled: false, // 不显示元素路径
        zIndex: 9,
        maximumWords: 5000,
        toolbars: [[
            'underline',
            // 'simpleupload',
            'spechars',
            'kityformula',
            // 'fontpoint',
            'emptyunderline'
        ]],
        enterTag : 'br',
        // serverUrl: 'http://35.201.165.105:8000/controller.php'
      },
      is_view: false,
      paperName: '',
      // 试题总分
      max_score: 100,
      // 学生答题卡数量
      user_answer_sheet_length: 0,
      num: 0,
      dialogVisible: false,
      dialogImageUrl: '',
      local_pic_arr: [
          // {
          //     name: 'http://s.eoffcn.com/tiku/answersheet/20190918/Android_06fff5e61b9e520b551ae7b5850ebd4f.jpg',
          //     url: 'http://s.eoffcn.com/tiku/answersheet/20190918/Android_06fff5e61b9e520b551ae7b5850ebd4f.jpg'
          // }
      ],
      http_pic_arr: [],
      pic_toast: false,
      text_remark_id: null,
    }
  },
  created () {
    window.utils.documentSetTitle('教师点评');
    if (process.env.NODE_ENV=='production') {
      this.uploadUrl = global_.global.online_url + '/api/admin/library/uploadImg'
    } else if (process.env.NODE_ENV=='testing') {
      this.uploadUrl = global_.global.test_url + '/api/admin/library/uploadImg'
    } else {
      this.uploadUrl = global_.global.local_url + '/api/admin/library/uploadImg'
    }
    this.paperName = window.localStorage.getItem('paper_name') + ' - ' + this.$route.params.question_num;
    this.max_score = Number(this.$route.params.question_score);
    this.user_answer_sheet_length = this.$route.params.user_answer_sheet_length;
    this.question_mode = Number(this.$route.params.question_mode);
    this.is_view = window.localStorage.getItem('user_no') != this.$route.params.correct_user;
    // this.is_view = this.$route.params.action_type == 3 ? true : false;
    if (!this.is_view) {
      this.getUserCorrectExplain();
    } else {
      // 富文本编辑器只读
      this.config.readonly = true;
    }

  },
  mounted() {
    // 修改或查看时
    if (this.$route.params.action_type == 1 || this.is_view) {
      this.getTeacherRemark();
    }
  },
  methods: {
    // 视频上传
    videoUpload (obj) {
      console.log('视频---------->', obj);
    },
    // 录制视频组件错误处理器
    errorLister (err) {
      console.log(err);
      this.$confirm(err.message, err.title, {
        confirmButtonText: '我知道了',
        type: 'warning',
        // center: true,
        showClose:false,
        showCancelButton: false
      }).then(() => {
      }).catch(() => {
      });
    },
    RecordVideoOpen () {
      this.RecordVideo = true;
    },
    // 查看教师点评信息
    getTeacherRemark () {
      this.$api.GETTEACHERREMARK({
        job_id: this.$route.params.job_id,
        job_sub_id: this.$route.params.job_sub_id,
        question_id: this.$route.params.question_id,
      }).then(res => {
        if (res.retcode == 0) {
          // 答题卡
          this.local_pic_arr = res.data.img_remark.map(item => {
            this.http_pic_arr.push(item.correct_img);
            return {
              name: item.correct_img,
              url: item.correct_img
            }
          })
          this.text_remark_id = res.data.text_remark.text_remark_id;
          // 教师评分
          this.num = res.data.text_remark.question_score;
          // 总体评价
          this.question_evaluation = res.data.text_remark.question_evaluation;
          if (this.$refs.ueditor_1) {
            this.$refs.ueditor_1.setUEContent(this.question_evaluation);
          }
          // 问题
          this.question_issue = res.data.text_remark.question_issue;
          // this.$refs.ueditor_2.setUEContent(this.question_issue);
          if (this.$refs.ueditor_2) {
            this.$refs.ueditor_2.setUEContent(this.question_issue);
          }
          // 优点
          this.question_merit = res.data.text_remark.question_merit;
          // this.$refs.ueditor_3.setUEContent(this.question_merit);
          if (this.$refs.ueditor_3) {
            this.$refs.ueditor_3.setUEContent(this.question_merit);
          }
          // 建议
          this.question_advice = res.data.text_remark.question_advice;
          // this.$refs.ueditor_4.setUEContent(this.question_advice);
          if (this.$refs.ueditor_4) {
            this.$refs.ueditor_4.setUEContent(this.question_advice);
          }
        } else {
          this.$message.error(res.message);
        }
      })
    },
    // 获取批改说明阅读状态
    getUserCorrectExplain () {
      this.$api.GETUSERCORRECTEXPLAIN().then(res => {
        if (res.retcode == 0) {
          if (!res.data.set_status) {
            // 每次提醒
            this.goCorrectExplainView();
          }
        } else {
          this.$message.error(res.message);
        }
      })
    },
    goCorrectExplainView () {
      let routeUrl = this.$router.resolve({
          path: "/correct-explain"
      });
      window.open(routeUrl .href, '_blank');
    },
    beforeUpload (a) {
      return new Promise((resolve, reject) => {
        if (this.http_pic_arr.length >= this.user_answer_sheet_length && !this.pic_toast) {
          this.$confirm('<p style="color:#bbb;">继续上传将超过学员答题卡数量，确定要上传吗？</p>', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            showClose:false,
            closeOnClickModal:false,
            dangerouslyUseHTMLString:true,
            showCancelButton:true
          }).then(() => {
            resolve ('继续上传');
          }).catch(() => {
            reject('停止上传');
          });
          this.pic_toast = true;
          return;
        }
        resolve ('继续上传');
        // reject('停止上传');
      })
    },
    // 上传图片
    uploadFile (params) {
      var file = params.file
      var formData = new FormData();
      formData.append('img', file);
      this.$api.UPLOADIMAGE(formData).then(res => {
        this.pic_err_msg = '';
        if (res.retcode == 0) {
          this.http_pic_arr.push(res.data.img_url);
        } else {
          if (this.$refs.upload.uploadFiles.length) {
            this.$refs.upload.uploadFiles.splice(-1, 1);
          }
          this.$message.error(res.message);
        }
      }).catch(err => {
        if (this.$refs.upload.uploadFiles.length) {
          this.$refs.upload.uploadFiles.splice(-1, 1);
        }
      })
    },
    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove (file) {
      let idx;
      this.$refs.upload.uploadFiles.forEach((item, index) => {
        if (item.url == file.url) {
          idx = index;
        }
      });
      this.$refs.upload.uploadFiles.splice(idx, 1);
      this.http_pic_arr.splice(idx, 1);
    },
    // 校验
    check () {
        if (this.num == null || this.num == 'undefined') {
            this.err_msg = '请输入教师评分';
            return false;
        }
        if (this.num > this.max_score ) {
            this.err_msg = `评分不能超过总分(${this.max_score})`;
            return false;
        }
        this.err_msg = '';
        return true;
    },
    check_pic () {
      if (!this.http_pic_arr.length) {
        this.$message.error('答题卡批改为必填项');
        return false;
      }
      if (this.http_pic_arr.length < this.user_answer_sheet_length) {
        this.pic_err_msg = '上传的图片数量小于学员答题卡数量';
        return false;
      }
      this.pic_err_msg = '';
      return true;
    },
    check_words () {
      if (!this.question_mode) {
        // 作文题
        if (!this.$refs.ueditor_1.getUEContent()) {
          this.$message.error('总体评价为必填项');
          return false;
        }
        if (!this.$refs.ueditor_2.getUEContent()) {
          this.$message.error('问题为必填项');
          return false;
        }
        if (!this.$refs.ueditor_3.getUEContent()) {
          this.$message.error('优点为必填项');
          return false;
        }
        if (!this.$refs.ueditor_4.getUEContent()) {
          this.$message.error('建议为必填项');
          return false;
        }
      } else {
        if (!this.$refs.ueditor_2.getUEContent()) {
          this.$message.error('问题为必填项');
          return false;
        }
      }
      return true;
    },
    cancel () {
      console.log('取消操作');
      window.close();
    },
    save () {
      // 校验
      if (this.check() && this.check_pic() && this.check_words()) {
        var params;
        // 修改
        if (this.$route.params.action_type == 1) {
          params = {
            text_remark_id: this.text_remark_id,
            question_id: this.$route.params.question_id,
            question_type: Number(this.question_mode) + 1,
            question_score: this.num,
            question_issue: this.$refs.ueditor_2.getUEContent(),
            correct_img_data: JSON.stringify(this.http_pic_arr)
          }
          if (!this.question_mode) {
            params.question_evaluation = this.$refs.ueditor_1.getUEContent();
            params.question_merit = this.$refs.ueditor_3.getUEContent();
            params.question_advice = this.$refs.ueditor_4.getUEContent();
          }
          this.$api.EDITTEACHERREMARK(params).then(res => {
            if (res.retcode == 0) {
                console.log('修改教师点评-添加成功');
                this.$message({
                  message: '保存成功',
                  type: 'success',
                  onClose: () => {
                    window.close();
                  }
                });
            } else {
              this.$message.error(res.message);
            }
          })
          return;
        }
        // 添加
        // 接口
        params = {
          job_id: this.$route.params.job_id,
          job_sub_id: this.$route.params.job_sub_id,
          question_id: this.$route.params.question_id,
          question_type: Number(this.question_mode) + 1,
          question_score: this.num,
          question_issue: this.$refs.ueditor_2.getUEContent(),
          correct_img_data: JSON.stringify(this.http_pic_arr)
        }
        if (!this.question_mode) {
          params.question_evaluation = this.$refs.ueditor_1.getUEContent();
          params.question_merit = this.$refs.ueditor_3.getUEContent();
          params.question_advice = this.$refs.ueditor_4.getUEContent();
        }
        this.$api.ADDTEACHERREMARK(params).then(res => {
            if (res.retcode == 0) {
                console.log('教师点评-添加成功');
                // 通知父组件已点评
                var bc = new BroadcastChannel('test_channel');
                bc.postMessage(this.$route.params.question_id);
                this.$message({
                  message: '保存成功',
                  type: 'success',
                  onClose: () => {
                    window.close();
                  }
                });
            } else {
              this.$message.error(res.message);
            }
        })
      }

    }
  }
}
</script>

<style lang="less" scoped>
.teacher-assess-page {
  height: 100%;
  .font-12 {
    font-size: 12px;
  }
  .page-title {
    width: 100%;
    height: 80px;
    padding: 0 20px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 99;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    .words-box {
      height: 100%;
      flex: 1 0 auto;
      display: flex;
      align-items: center;
      height: fit-content;
      // align-self: center;
      .title {
        font-size: 20px;
        font-weight: bolder;
        margin-right: 10px;
      }
      .name {
        margin-left: 40px;
      }
    }
    .button-box {
      height: fit-content;
    }
  }
  .page-content {
    padding: 80px 50px 0;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    .part {
      margin: 20px 0 0;
      .red {
        color: red;
      }
      .part-title {
        font-weight: bolder;
        margin: 0 0 20px;
      }
      .part-content {
        .item-title {
          &::before {
              content: "";
              position: absolute;
              left: 0;
              top: 4px;
              height: 17px;
              width: 3px;
              background-color: #1890ff;
          }
          font-size: 14px;
          font-weight: bolder;
          position: relative;
          height: 25px;
          padding-left: 5px;
          margin: 10px 0;
        }
        .item-content {
          margin: 0 0 20px;
        }
      }
    }
  }
}
</style>
<style>
.teacher-assess-page .page-content .is_view .el-upload.el-upload--picture-card {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/pages/teacher-assess/index.vue